/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HchbAdmissionCoordinatorSummary
 */
export interface HchbAdmissionCoordinatorSummary {
    /**
     * 
     * @type {string}
     * @memberof HchbAdmissionCoordinatorSummary
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof HchbAdmissionCoordinatorSummary
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof HchbAdmissionCoordinatorSummary
     */
    worker_name?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbAdmissionCoordinatorSummary
     */
    street?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbAdmissionCoordinatorSummary
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbAdmissionCoordinatorSummary
     */
    state?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbAdmissionCoordinatorSummary
     */
    zip?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbAdmissionCoordinatorSummary
     */
    phone?: string;
}

/**
 * Check if a given object implements the HchbAdmissionCoordinatorSummary interface.
 */
export function instanceOfHchbAdmissionCoordinatorSummary(value: object): value is HchbAdmissionCoordinatorSummary {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function HchbAdmissionCoordinatorSummaryFromJSON(json: any): HchbAdmissionCoordinatorSummary {
    return HchbAdmissionCoordinatorSummaryFromJSONTyped(json, false);
}

export function HchbAdmissionCoordinatorSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): HchbAdmissionCoordinatorSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'worker_name': json['worker_name'] == null ? undefined : json['worker_name'],
        'street': json['street'] == null ? undefined : json['street'],
        'city': json['city'] == null ? undefined : json['city'],
        'state': json['state'] == null ? undefined : json['state'],
        'zip': json['zip'] == null ? undefined : json['zip'],
        'phone': json['phone'] == null ? undefined : json['phone'],
    };
}

export function HchbAdmissionCoordinatorSummaryToJSON(json: any): HchbAdmissionCoordinatorSummary {
    return HchbAdmissionCoordinatorSummaryToJSONTyped(json, false);
}

export function HchbAdmissionCoordinatorSummaryToJSONTyped(value?: HchbAdmissionCoordinatorSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'worker_name': value['worker_name'],
        'street': value['street'],
        'city': value['city'],
        'state': value['state'],
        'zip': value['zip'],
        'phone': value['phone'],
    };
}

